"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const reusables_1 = require("../../../../comps/reusables");
const reactstrap_1 = require("reactstrap");
const constants_1 = require("../../../../constants");
const graphql_1 = require("../../../../graphql");
const react_loops_1 = require("react-loops");
const react_2 = require("@osmosys/react");
exports.AdminSettings = props => {
    const agreedToTermsOfService = !!(props.workspace.agreedToTermsOfServiceUser &&
        props.workspace.agreedToTermsOfServiceDate);
    return (react_1.default.createElement(react_2.OsmosysSmallContainer, null,
        react_1.default.createElement(reusables_1.Form, { formikProps: {
                initialValues: {
                    agreedToTermsOfService,
                    archived: props.workspace.archived,
                    dashboardUrls: props.workspace.dashboardUrls,
                    enabledIntegrationClasses: props.workspace.enabledIntegrationClasses.map(cls => constants_1.INTEGRATION_OPTIONS.find(opt => opt.value === cls)),
                    enableSubscriberTools: props.workspace.enableSubscriberTools,
                    featureFlagOverrides: props.workspace.featureFlagOverrides,
                    helpLink: props.workspace.helpLink || '',
                    isUserAnalyticsEnabled: props.workspace.isUserAnalyticsEnabled,
                    isWorkspaceAnalyticsEnabled: props.workspace.isWorkspaceAnalyticsEnabled,
                    name: props.workspace.name,
                },
            }, mutationProps: {
                mutation: graphql_1.updateWorkspace,
                refetchQueries: [
                    {
                        query: graphql_1.currentUser,
                    },
                ],
            }, valuesToVariables: values => ({
                data: {
                    agreedToTermsOfService: values.agreedToTermsOfService === true,
                    archived: values.archived,
                    dashboardUrls: values.dashboardUrls,
                    enabledIntegrationClasses: values.enabledIntegrationClasses.map(opt => opt.value),
                    enableSubscriberTools: values.enableSubscriberTools,
                    featureFlagOverrides: values.featureFlagOverrides,
                    helpLink: values.helpLink || '',
                    isUserAnalyticsEnabled: values.isWorkspaceAnalyticsEnabled &&
                        values.isUserAnalyticsEnabled,
                    isWorkspaceAnalyticsEnabled: values.isWorkspaceAnalyticsEnabled,
                    name: values.name,
                },
                id: props.workspace.id,
            }), showBottomToolbar: true }, formikProps => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(reusables_1.FormGroup, { label: "Disable access", type: "checkbox", options: constants_1.INTEGRATION_OPTIONS, name: "archived" }),
                react_1.default.createElement(reusables_1.FormGroup, { label: "Enable subscriber tools (Mailchimp only right now)", type: "checkbox", name: "enableSubscriberTools" }),
                react_1.default.createElement(reusables_1.FormGroup, { label: "Workspace-granular analytics", type: "checkbox", options: constants_1.INTEGRATION_OPTIONS, name: "isWorkspaceAnalyticsEnabled" }),
                react_1.default.createElement(reusables_1.FormGroup, { label: "User-granular analytics", type: "checkbox", options: constants_1.INTEGRATION_OPTIONS, name: "isUserAnalyticsEnabled", disabled: !formikProps.values.isWorkspaceAnalyticsEnabled }),
                react_1.default.createElement(reusables_1.FormGroup, { label: "Enabled integrations", type: "select", selectProps: {
                        isClearable: true,
                        isMulti: true,
                    }, options: constants_1.INTEGRATION_OPTIONS, name: "enabledIntegrationClasses" }),
                react_1.default.createElement(DashboardsInput, { value: formikProps.values.dashboardUrls, onChange: newArray => {
                        formikProps.setFieldValue('dashboardUrls', newArray);
                    } }),
                react_1.default.createElement(reusables_1.FormGroup, { label: "Help link", type: "text", name: "helpLink" }),
                react_1.default.createElement("h2", { className: "text-center" }, "Feature Flags"),
                react_1.default.createElement(reusables_1.FeatureFlagsForm, { featureFlagOverrides: formikProps.values.featureFlagOverrides, onChange: featureFlags => {
                        formikProps.setFieldValue('featureFlagOverrides', featureFlags);
                    } }),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null)))))));
};
function DashboardsInput({ value, onChange, }) {
    value = Array.isArray(value) ? value : [];
    // Disabled
    const disabled = react_1.useMemo(() => {
        if (value.length === 0) {
            return false;
        }
        if (value.find(v => v.trim().length === 0)) {
            return true;
        }
        return false;
    }, [value]);
    return (react_1.default.createElement(reactstrap_1.FormGroup, null,
        react_1.default.createElement(reactstrap_1.Label, { className: "font-weight-bold" }, "Dashboard URLs"),
        react_1.default.createElement(react_loops_1.For, { of: value, ifEmpty: react_1.default.createElement(react_1.default.Fragment, null) }, (item, { index }) => {
            return (react_1.default.createElement(WorkspaceDashboardUrlInput, { item: item, onDelete: () => {
                    const newArray = [...value];
                    newArray.splice(index, 1);
                    onChange(newArray);
                }, onChange: newVal => {
                    const newArray = [...value];
                    newArray[index] = newVal;
                    onChange(newArray);
                } }));
        }),
        react_1.default.createElement("div", null,
            react_1.default.createElement(reactstrap_1.Button, { onClick: () => {
                    onChange([...value, '']);
                }, size: "sm", outline: true, disabled: disabled },
                react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "plus" }),
                " Add dashboard"))));
}
function WorkspaceDashboardUrlInput({ item, onChange, onDelete, }) {
    return (react_1.default.createElement("div", { className: "flex-row mb-2" },
        react_1.default.createElement(reactstrap_1.Input, { value: item, onChange: ({ target: { value } }) => {
                onChange(value);
            } }),
        react_1.default.createElement("div", { className: "flex-col-centered text-muted" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(reactstrap_1.Button, { onClick: () => {
                        onDelete();
                    }, size: "sm", color: "link", className: "text-reset" },
                    react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "trash" }))))));
}
//# sourceMappingURL=AdminSettings.js.map